/**
 * Account – SVG icon.
 */
import Screen from '@screen';

export default function AccountIcon({
  width,
  height,
  margin,
}: {
  width?: number;
  height?: number;
  margin?: string;
}) {
  return (
    <svg
      width={(width ? width : 116) * Screen.widthRatio}
      height={(height ? height : 85) * Screen.widthRatio}
      viewBox='0 0 116 85'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M104.188 0C110.74 0 116 5.48421 116 12.1562V72.7529C116 79.4249 110.74 84.9082 104.188 84.9082H70.5566C70.4033 85.0344 70.2237 85.0222 70.0674 84.9082H11.8125V85C5.26039 85 0 79.5158 0 72.8438V12.1562C0 5.48421 5.26039 0 11.8125 0H104.188ZM11.8125 4.84375C7.84432 4.84375 4.70605 8.13474 4.70605 12.1562V72.7529C4.70615 75.7473 6.49793 78.3348 9.0127 79.4619C9.03107 79.2658 9.06976 79.0688 9.12793 78.873C11.8027 69.928 18.0741 62.6256 26.1904 58.792L28.0352 57.8799L26.4668 56.5107C21.8552 52.5859 19.1807 46.7434 19.1807 40.6279C19.1809 29.2186 28.2199 20 39.1953 20C50.2629 20.0001 59.2088 29.2187 59.209 40.6279C59.209 46.7434 56.5344 52.5859 51.9229 56.5107L50.3555 57.8799L52.2002 58.792C59.7871 62.3254 67.0277 70.9885 70.0781 80.0645H104.188C108.156 80.0645 111.294 76.7743 111.294 72.7529V12.1562C111.294 8.13474 108.063 4.84375 104.188 4.84375H11.8125ZM39.1953 61.5303C27.9114 61.5303 17.9748 68.9945 14.4336 80.0645H62.5156C57.9391 70.0556 48.8804 61.5304 39.1953 61.5303ZM39.3799 25.75C31.3559 25.75 24.8069 32.4133 24.8066 40.6279C24.8066 48.8428 31.3557 55.5068 39.3799 55.5068C47.4039 55.5066 53.9521 48.8426 53.9521 40.6279C53.8597 32.4134 47.4037 25.7502 39.3799 25.75ZM99.4229 48.8428C100.898 48.843 102.096 50.0297 102.097 51.5811C102.097 53.1326 100.898 54.3191 99.4229 54.3193H67.5098C66.0343 54.3191 64.8359 53.1326 64.8359 51.5811C64.8362 50.0297 66.0344 48.843 67.5098 48.8428H99.4229ZM105.325 34.3301C106.801 34.3301 108 35.5168 108 37.0684C108 38.6201 106.801 39.8066 105.325 39.8066H67.5098C66.0343 39.8064 64.8359 38.6199 64.8359 37.0684C64.8361 35.5169 66.0343 34.3303 67.5098 34.3301H105.325ZM105.325 20.7305C106.801 20.7305 108 21.9171 108 23.4688C108 25.0203 106.801 26.207 105.325 26.207H67.5098C66.0343 26.2068 64.8361 25.0202 64.8359 23.4688C64.8359 21.9172 66.0343 20.7307 67.5098 20.7305H105.325Z'
        fill='url(#paint0_linear_settings_account)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_settings_account'
          x1='58'
          y1='0'
          x2='58'
          y2='85'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
      </defs>
    </svg>
  );
}
